import { useToggleTabs } from './useToggleTabs';
export function ToggleTabsContent(props) {
    const { tabKey, children } = props;
    const { activeTab } = useToggleTabs();
    if (activeTab !== tabKey) {
        return null;
    }
    return children;
}
